import { render, staticRenderFns } from "./noticePanel.vue?vue&type=template&id=32ee0c7a&scoped=true"
import script from "./noticePanel.vue?vue&type=script&lang=js"
export * from "./noticePanel.vue?vue&type=script&lang=js"
import style0 from "./noticePanel.vue?vue&type=style&index=0&id=32ee0c7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ee0c7a",
  null
  
)

export default component.exports